import { render, staticRenderFns } from "./BasePriceList.vue?vue&type=template&id=db175624&scoped=true"
import script from "./BasePriceList.vue?vue&type=script&lang=js"
export * from "./BasePriceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db175624",
  null
  
)

export default component.exports